module.exports = __webpack_public_path__ + "static/media/Gorilla.3c8b5bab.png";